//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
	}
	//#endregion

	return {
		outerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
				padding: `${minimumMarginX}rem`,
			};
		},
		largeText: () => {
			return {
				fontSize: '1.5rem',
				fontWeight: 700,
			};
		},
	};
}

export default Styles;
